export class EnterValue {
    label = 'Wert';
    type = 'text';
    value: any = null;
    inputmode = 'text';
    showHidePassword = false;
    rows: number = 3;
    suffixIcon: string;
}

export class EnterValueInput {
    title = 'Bitte Wert eingeben';
    text = 'Bitte geben Sie einen Wert ein.';
    html: string;
    okButton = 'Speichern';
    buttonColor = 'accent';
    buttonsToCorners = false;

    values: EnterValue[] = [];

    constructor() {}

    addInputValue(
        label: string,
        inputmode: 'text' | 'textarea' | 'decimal' | 'numeric' | 'password' | 'date' | 'toggle',
        value?: any,
        suffixIcon?: string,
    ) {
        const ev = new EnterValue();
        ev.label = label;
        ev.inputmode = inputmode;
        if (value) {
            ev.value = value;
        }
        if (inputmode === 'text') {
            ev.type = 'text';
        } else if (inputmode === 'textarea') {
            ev.type = 'textarea';
        } else if (inputmode === 'decimal' || inputmode === 'numeric') {
            ev.type = 'number';
        } else if (inputmode === 'password') {
            ev.type = 'password';
            ev.showHidePassword = true;
        } else if (inputmode === 'date') {
            ev.type = 'date';
        } else if (inputmode === 'toggle') {
            ev.type = 'toggle';
        }
        if (suffixIcon) {
            ev.suffixIcon = suffixIcon;
        }
        this.values.push(ev);
    }
}

export class EnterValueResponse {
    values: any[] = [];
    result: boolean;

    getValue(index: number): any {
        if (!this.values || index >= this.values.length) {
            return null;
        }
        return this.values[index];
    }

    addValue(value: any) {
        this.values.push(value);
    }
}
